import '@mdi/font/css/materialdesignicons.css';
window.Vue=require('vue');
import { InertiaApp } from '@inertiajs/inertia-vue';
import Vue from 'vue';
import Vuetify from 'vuetify';
//import VueApexCharts from 'vue-apexcharts'

Vue.config.productionTip=false;
Vue.mixin({methods: {route: window.route}});
Vue.use(InertiaApp);
Vue.use(Vuetify);
//Vue.use(VueApexCharts)
//Vue.component('apexchart', VueApexCharts)

let app=document.getElementById('app');
let vuetify=new Vuetify();
//let apexcharts=new VueApexCharts();

new Vue({
    vuetify,
//    apexcharts,
    render: h=>h(InertiaApp, {
            props: {
                initialPage: JSON.parse(app.dataset.page),
                resolveComponent: name=>import(`@/Pages/${name}`).then(module=>module.default)
            }
        })
}).$mount(app);